import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { parseAirDateToISO } from "@air/utilities";
export const SharePrivateContentLinkFooter = (param)=>{
    let { createdAt, createdBy } = param;
    const formattedCreatedAt = new Date(parseAirDateToISO(createdAt)).toLocaleString();
    return /*#__PURE__*/ _jsxs("div", {
        className: "-mx-2 -mb-2 flex flex-col border-t border-t-grey-5 px-3.5 py-3 text-12 text-grey-9",
        children: [
            !!createdBy && /*#__PURE__*/ _jsxs("div", {
                children: [
                    "Link created by ",
                    createdBy
                ]
            }),
            !!formattedCreatedAt && /*#__PURE__*/ _jsx("time", {
                dateTime: createdAt,
                children: formattedCreatedAt
            })
        ]
    });
};
